
    import './styles.scoped.css';
    export default {
  "flash-with-motion": "awsui_flash-with-motion_1q84n_qt4pn_99",
  "enter": "awsui_enter_1q84n_qt4pn_99",
  "flash-body": "awsui_flash-body_1q84n_qt4pn_113",
  "flash-message": "awsui_flash-message_1q84n_qt4pn_113",
  "flash-header": "awsui_flash-header_1q84n_qt4pn_113",
  "flash-content": "awsui_flash-content_1q84n_qt4pn_114",
  "action-button-wrapper": "awsui_action-button-wrapper_1q84n_qt4pn_115",
  "dismiss-button-wrapper": "awsui_dismiss-button-wrapper_1q84n_qt4pn_116",
  "flash-icon": "awsui_flash-icon_1q84n_qt4pn_139",
  "entering": "awsui_entering_1q84n_qt4pn_152",
  "entered": "awsui_entered_1q84n_qt4pn_173",
  "exiting": "awsui_exiting_1q84n_qt4pn_278",
  "stack": "awsui_stack_1q84n_qt4pn_300",
  "animation-running": "awsui_animation-running_1q84n_qt4pn_300",
  "item": "awsui_item_1q84n_qt4pn_300",
  "flash-list-item": "awsui_flash-list-item_1q84n_qt4pn_301",
  "notification-bar": "awsui_notification-bar_1q84n_qt4pn_302",
  "collapsed": "awsui_collapsed_1q84n_qt4pn_322",
  "animation-ready": "awsui_animation-ready_1q84n_qt4pn_322",
  "expanded-only": "awsui_expanded-only_1q84n_qt4pn_322",
  "expanded": "awsui_expanded_1q84n_qt4pn_322",
  "flash": "awsui_flash_1q84n_qt4pn_99",
  "collapsible": "awsui_collapsible_1q84n_qt4pn_386",
  "short-list": "awsui_short-list_1q84n_qt4pn_392",
  "visual-refresh": "awsui_visual-refresh_1q84n_qt4pn_392",
  "status": "awsui_status_1q84n_qt4pn_605",
  "header": "awsui_header_1q84n_qt4pn_605",
  "item-count": "awsui_item-count_1q84n_qt4pn_606",
  "button": "awsui_button_1q84n_qt4pn_607",
  "type-count": "awsui_type-count_1q84n_qt4pn_640",
  "count-number": "awsui_count-number_1q84n_qt4pn_640",
  "icon": "awsui_icon_1q84n_qt4pn_674",
  "floating": "awsui_floating_1q84n_qt4pn_715",
  "flashbar": "awsui_flashbar_1q84n_qt4pn_723",
  "flash-refresh": "awsui_flash-refresh_1q84n_qt4pn_798",
  "flash-list": "awsui_flash-list_1q84n_qt4pn_301",
  "flash-focus-container": "awsui_flash-focus-container_1q84n_qt4pn_819",
  "flash-text": "awsui_flash-text_1q84n_qt4pn_849",
  "dismiss-button": "awsui_dismiss-button_1q84n_qt4pn_116",
  "breakpoint-default": "awsui_breakpoint-default_1q84n_qt4pn_891",
  "action-button": "awsui_action-button_1q84n_qt4pn_115",
  "action-slot": "awsui_action-slot_1q84n_qt4pn_901",
  "flash-type-success": "awsui_flash-type-success_1q84n_qt4pn_905",
  "flash-type-error": "awsui_flash-type-error_1q84n_qt4pn_909",
  "flash-type-info": "awsui_flash-type-info_1q84n_qt4pn_913",
  "flash-type-in-progress": "awsui_flash-type-in-progress_1q84n_qt4pn_914",
  "flash-type-warning": "awsui_flash-type-warning_1q84n_qt4pn_918"
};
  